import React from "react";
import protectedImg from "../../../../../assets/images/DeathModuleNew/protected.svg";
import addIcon from "../../../../../assets/images/DeathModuleNew/addIcon.png";
import NewLoader from "../../../../../components/styled-components/loader/NewLoader";
import moment from "moment";
import { useHistory } from "react-router-dom";
import { setActiveStep } from "../../../../../redux/slices/loginSlice";
import { useDispatch, useSelector } from "react-redux";
import { ToolTipCreator } from "../../../../../helpers/ToolTipCreator";

export const DisabilityLegalDocumentCard = ({ loading, step, moduleData }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  return (
    <div className="DisabilityCardMain" style={{ position: "relative" }}>
      <div className="cardHeadingDisability">
      <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
      <img width={66} height={56} src={moduleData.Icon} alt={moduleData.name}></img>
        {/* {moduleData.name} */}
          <div style={{ display: "flex", alignItems: "baseline", columnGap: "3px" }}>
            {moduleData.name}
            {moduleData &&
              moduleData.tooltip &&
              ["Legal Documents"].includes(moduleData.name) && (
                <ToolTipCreator name={moduleData.tooltip} />
            )}
          </div>           
        </div>
        <div className="uploadButtonsDisability">
          {" "}
          <div
            className="upload"
            style={{ width: "20px", height: "20px" }}
            onClick={() => {
              dispatch(setActiveStep(step));
              history.push("/protector/disability");
            }}
          >
            <img
              src={addIcon}
              width={12}
              height={12}
              style={{ width: "12px", height: "12px" }}
              alt="addicon"
            ></img>
          </div>
        </div>
      </div>
      <div className="cardDisabilityDesc">{moduleData.Purpose}</div>
      <div className="disabilityDashboardLegalCard">
        <div className="disabilityDashboardLegalCardInner">
          This Information will be available you soon!
          <img
            src={protectedImg}
            style={{ width: "50px", height: "50px", marginTop: "8px" }}
            alt="protectedImg"
          ></img>
        </div>
      </div>
      <NewLoader isLoading={loading} />
    </div>
  );
};
